import React from 'react';

const defaultContext = {
  isAVehicle() { return false; }
};

const ToolContext = React.createContext(defaultContext);

export {
  defaultContext,
  ToolContext
};
